import { CircularProgress, IconButton, Pagination } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { DataGrid, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { getPerPageRecords, getPermissionData, getUserData } from "../../Actions/common";
import { deleteMultipleLogsAction, exportSystemLogDataAction, getModulesOptionsActions, logsFilterAction } from "../../Actions/LogsAction";
import { DataGrid_SX } from "../../Assets/customTheme/constants";
import { CustomNoRowsOverlay } from "../../Assets/customTheme/CustomNoRowsOverlay";
import { default as CoustomTooltip, default as CustomTooltip } from "../../Assets/customTheme/customtooltip";
import { MyDeleteOutlineOutlinedIcon } from "../../Assets/svg/MyIcons";
import { TableColumns, TableFilte, TableReset } from "../../Assets/svg/svgicon";
import BreadcrumbsComponent from "../../components/Common/Breadcrumbs";
import { DEFAULT_PAGE_SIZE, ITEMS_PER_PAGE_OPTIONS } from "../../config";
import { formatDateTime } from "../Common/DateFormat";
import CustomSnackbar from "../Common/snackBar";
import ExportDataModal from "../ExportDataModal";
import renderStatusBadge from "../../utils/badges";
import DateRangePicker from "../Common/DateRangePicker";
import showConfirmation from "../../utils/Conformation";
import { getUsersAction } from "../../Actions/UserActions";

const getDefaultDateRange = () => {
  const end = new Date();
  const start = new Date();
  start.setMonth(start.getMonth() - 1);

  return { from: start, to: end };
};

const CustomToolbar = ({
  selectedRows,
  handleDeleteSelected,
  handleFilterData,
  handleResetFilters,
  handleChangeDropdown,
  typeFilter,
  userOperationFilter,
  userNameFilter,
  usersDataForDropdown,
  logsData,
  moduleId,
  moduleOptions,
  filterButtonDisabled,
  resetButtonDisabled,
  selectedRange,
  onRangeChange,
}) => {
  const userData = localStorage.getItem("userData") ? getUserData() : null;
  return (
    <div className="custom-header">
      <div className="card border-rounded-0 fiter-card">
        <div className="card-body p-5 pb-0">
          <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={userOperationFilter}
                  name="dropdown"
                  onChange={(e) => handleChangeDropdown(e, "userOperation")}
                  input={<OutlinedInput />}
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "12px 10px",
                      textAlign: "start",
                      minHeight: "1em !important",
                    },
                    fieldset: {
                      borderColor: "#e1e3ea !important",
                      borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Operations</MenuItem>
                  <MenuItem value="Create">Create</MenuItem>
                  <MenuItem value="Update">Update</MenuItem>
                  <MenuItem value="Delete">Delete</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={moduleId}
                  name="dropdown"
                  onChange={(e) => handleChangeDropdown(e, "module")}
                  input={<OutlinedInput />}
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "12px 10px",
                      textAlign: "start",
                      minHeight: "1em !important",
                    },
                    fieldset: {
                      borderColor: "#e1e3ea !important",
                      borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Modules</MenuItem>
                  {moduleOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div className="col-lg-2 col-md-4 col-sm-6 mb-5">
              <FormControl className="w-100">
                <Select
                  displayEmpty
                  value={typeFilter}
                  name="dropdown"
                  onChange={(e) => handleChangeDropdown(e, "type")}
                  input={<OutlinedInput />}
                  sx={{
                    "& .MuiSelect-select": {
                      padding: "12px 10px",
                      textAlign: "start",
                      minHeight: "1em !important",
                    },
                    fieldset: {
                      borderColor: "#e1e3ea !important",
                      borderRadius: "0.475rem",
                    },
                  }}
                >
                  <MenuItem value="all">All Type</MenuItem>
                  <MenuItem value="success">Success</MenuItem>
                  <MenuItem value="error">Error</MenuItem>
                </Select>
              </FormControl>
            </div>
            {userData && (userData?.role?.isAdmin || userData?.role?.isSuperAdmin) && (
              <div className="col-lg-2 col-md-4 col-sm-6 mb-5">
                <FormControl className="w-100">
                  <Select
                    displayEmpty
                    value={userNameFilter}
                    name="dropdown"
                    onChange={(e) => handleChangeDropdown(e, "users")}
                    input={<OutlinedInput />}
                    sx={{
                      "& .MuiSelect-select": {
                        padding: "12px 10px",
                        textAlign: "start",
                        minHeight: "1em !important",
                      },
                      fieldset: {
                        borderColor: "#e1e3ea !important",
                        borderRadius: "0.475rem",
                      },
                    }}
                  >
                    <MenuItem value={0}>All Users</MenuItem>
                    {usersDataForDropdown &&
                      usersDataForDropdown.map((option) => {
                        const userName = `${JSON.parse(option?.firstName)} ${JSON.parse(option?.lastName)}`
                        return <MenuItem key={option.id} value={option.id}>{userName}</MenuItem>
                      })}
                  </Select>
                </FormControl>
              </div>
            )}
            <div className="col-lg-2 col-md-4 col-sm-6 mb-5 text-center">
              <DateRangePicker
                selectedRange={selectedRange}
                onRangeChange={onRangeChange}
                maxDate={new Date()}
                placeholder="Select date range"
              />
            </div>
            <div className="col-auto ms-auto mb-5">
              <div className="d-flex align-items-center gap-3">
                <CustomTooltip title="Filter" placement="top" arrow>
                  <span style={{ display: "inline-block" }}>
                    <button
                      className="btn text-primary btn-light btn-icon"
                      onClick={handleFilterData}
                      disabled={filterButtonDisabled}
                    >
                      <TableFilte />
                    </button>
                  </span>
                </CustomTooltip>
                <CustomTooltip title="Reset" placement="top" arrow>
                  <span style={{ display: "inline-block" }}>
                    <button
                      className="btn text-primary btn-light btn-icon"
                      onClick={handleResetFilters}
                      disabled={resetButtonDisabled}
                    >
                      <TableReset />
                    </button>
                  </span>
                </CustomTooltip>

                <CoustomTooltip title="Column Filter" placement="top" arrow>
                  <span style={{ display: "inline-block" }}>
                    <GridToolbarColumnsButton
                      slotProps={{
                        tooltip: { title: "" },
                        button: {
                          className:
                            "btn btn-light text-primary btn-icon grid-toolbar d-flex justify-content-center align-items-center p-0",
                          style: {
                            width: "47px",
                            height: "44px",
                            minWidth: "unset",
                            borderRadius: "8px",
                          },
                          startIcon: <TableColumns />,
                        },
                      }}
                    />
                  </span>
                </CoustomTooltip>

                {selectedRows.length !== 0 && (
                  <CoustomTooltip title="Delete" placement="top" arrow>
                    <button
                      className="btn btn-outline-danger btn-icon btn-outline "
                      onClick={handleDeleteSelected}
                      disabled={selectedRows.length === 0}
                    >
                      <MyDeleteOutlineOutlinedIcon />
                    </button>
                  </CoustomTooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LogsSection = () => {
  const [logsData, setLogsData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const ITEMS_PER_PAGE = localStorage.getItem("GLOBAL_SETTING") ? getPerPageRecords() : { value: DEFAULT_PAGE_SIZE };
  const [filterButtonDisabled, setFilterButtonDisabled] = useState(true);
  const [resetButtonDisabled, setResetButtonDisabled] = useState(true);
  const [typeFilter, setTypeFilter] = useState("all");
  const [userOperationFilter, setUserOperationFilter] = useState("all");
  const [moduleId, setModuleId] = useState("all");
  const [userNameFilter, setUserNameFilter] = useState(0);
  const [usersDataForDropdown, setUsersDataForDropdown] = useState([]);
  const [startDate, setStartDate] = useState(getDefaultDateRange().from.toISOString());
  const [endDate, setEndDate] = useState(getDefaultDateRange().to.toISOString());
  const [selectedRange, setSelectedRange] = useState(getDefaultDateRange());
  const [shouldFetchData, setShouldFetchData] = useState(1);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [selectedDataForExport, setSelectedDataForExport] = useState([]);
  const [exportData, setExportData] = useState({});
  const [moduleOptions, setModuleOptions] = useState([]);

  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState(ITEMS_PER_PAGE_OPTIONS[0]);

  const [filtersApplied, setFiltersApplied] = useState(false);

  const [isUsersFetched, setIsUsersFetched] = useState(false);

  const userData = localStorage.getItem("userData") ? getUserData() : null;
  const permissionData = localStorage.getItem(`${userData?.id}_permissionData`) ? getPermissionData(`${userData?.id}_permissionData`) : [];
  const hasPermission = permissionData[0]?.role_permissions?.find((m) => m?.module && m?.module?.slug === "audit_trail");

  const fetchAllModulesOptions = async (isFilterAction = false) => {
    try {
      const response = await getModulesOptionsActions();
      const { data = null } = response?.data || {};
      if (data) {
        setModuleOptions(data);
      }
      if (isFilterAction) {
        setFilterButtonDisabled(true);
        setResetButtonDisabled(false);
        setFiltersApplied(true);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Something went wrong while fetching the modules list",
        severity: "error",
      });
      console.error("Error while fetching the module options ->", error);
    }
  };

  const fetchAllUsers = async () => {
    await getUsersAction(null, null, null, null, "1")
      .then((res) => {
        const { data } = res.data;
        setUsersDataForDropdown(data);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message || "Error fetching users",
          severity: "error",
        });
      });
  };

  const fetchFilteredLogsData = useCallback( async () => { 
    setLoading(true);
    await logsFilterAction(searchValue, currentPage, selectedRowsPerPage, typeFilter, userOperationFilter, moduleId, startDate, endDate, userNameFilter)
      .then((res) => {
        const { count, rows } = res.data.data;
        setLogsData(rows);
        setTotalRecords(count);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.response?.data?.message || "Error fetching logs",
          severity: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  },[searchValue, currentPage, selectedRowsPerPage, typeFilter, userOperationFilter, moduleId, startDate, endDate, userNameFilter]);

  useEffect(() => {
    fetchAllModulesOptions();
  }, []);

  useEffect(() => {
    if (!isUsersFetched) {
      setIsUsersFetched(true);
      fetchAllUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (shouldFetchData) {
      fetchFilteredLogsData(); 
      setShouldFetchData(0);
    }
  }, [shouldFetchData,fetchFilteredLogsData]);

  const handleSearchApi = (e) => {
    const inputValue = e.target.value.trim();
    setSearchValue(inputValue);
    if (inputValue.length > 0) {
      setFilterButtonDisabled(false);
    } else {
      setFilterButtonDisabled(true);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // const handleSelectAll = (event) => {
  //   if (event.target.checked) {
  //     const allIds = logsData.map((ele) => ele.id);
  //     setSelectedRows(allIds);
  //     setSelectedDataForExport(allIds);
  //   } else {
  //     setSelectedRows([]);
  //     setSelectedDataForExport([]);
  //   }
  // };

  // const handleRowSelection = (event, ele) => {
  //   const selectedId = ele.id;

  //   if (event.target.checked) {
  //     setSelectedRows((prevSelectedRows) => [...prevSelectedRows, selectedId]);
  //     setSelectedDataForExport((prevSelectedRows) => [...prevSelectedRows, selectedId]);
  //   } else {
  //     setSelectedRows((prevSelectedRows) => prevSelectedRows.filter((id) => id !== selectedId));
  //     setSelectedDataForExport([]);
  //   }
  // };

  const handleDelete = async (e, deleteId) => {
      e.stopPropagation();

      await showConfirmation("simpleDelete", {
          entityName: "Log",
          entityId: deleteId,
          action: deleteMultipleLogsAction,
          onSuccess: (res) => {
              setSelectedRows([]);
              setCurrentPage(1);
              fetchFilteredLogsData();
          },
          onError: (error) => {
              setSnackbar({
                  open: true,
                  message: error?.response?.data?.message || "Error deleting log",
                  severity: "error",
              });
          },
          showCancelledMsg: true,
      });
  };

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) {
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover these Log!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#22419e",
      cancelButtonColor: "#777777",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteMultipleLogsAction(selectedRows)
          .then((res) => {
            Swal.fire({
              title: "Deleted!",
              text: res.message,
              icon: "success",
              confirmButtonColor: "#22419e",
            });
          })
          .catch((error) => {
            setSnackbar({
              open: true,
              message: error.response?.data?.message || "Error deleting logs",
              severity: "error",
            });
          })
          .finally(() => {
            setSelectedRows([]);
            setCurrentPage(1);
            fetchFilteredLogsData();
          });
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your record is safe",
          icon: "error",
          confirmButtonColor: "#22419e",
        });
      }
    });
  };

  const handleChangeDropdown = (e, filterName) => {
    const selectedAction = e.target.value;
    if (selectedAction === "all" || selectedAction === 0) {
      setFilterButtonDisabled(true);
    } else {
      setFilterButtonDisabled(false);
    }
    if (filterName === "module") {
      setModuleId(selectedAction);
    } else if (filterName === "type") {
      setTypeFilter(selectedAction);
    } else if (filterName === "users") {
      setUserNameFilter(selectedAction);
    } else {
      setUserOperationFilter(selectedAction);
    }
  };

  const handleRangeChange = (range) => {
    setFilterButtonDisabled(false);

    if (filtersApplied) {
      setResetButtonDisabled(false);
    }

    if (!range) {
      setSelectedRange({ from: undefined, to: undefined });
      setStartDate(null);
      setEndDate(null);
      return;
    }

    setSelectedRange(range);

    if (range.from) {
      const year = range.from.getFullYear();
      const month = range.from.getMonth();
      const day = range.from.getDate();
      const startDateObj = new Date(Date.UTC(year, month, day, 0, 0, 0, 0));
      setStartDate(startDateObj.toISOString());
    }

    if (range.to) {
      const year = range.to.getFullYear();
      const month = range.to.getMonth();
      const day = range.to.getDate();
      const endDateObj = new Date(Date.UTC(year, month, day, 23, 59, 59, 999));
      setEndDate(endDateObj.toISOString());
    }
  };

  const handleRowsPerPageChange = (event) => {
    setLogsData([]);
    setSelectedRows([]);
    const newValue = parseInt(event.target.value);
    setSelectedRowsPerPage(newValue);
    setCurrentPage(1);
    setLoading(true);
    setShouldFetchData(1);
  };

  const handleResetFilters = () => {
    const defaultRange = getDefaultDateRange();
    setLoading(true);
    setLogsData([]);
    setTypeFilter("all");
    setUserOperationFilter("all");
    setModuleId("all");
    setUserNameFilter(0);
    setStartDate(defaultRange.from.toISOString());
    setEndDate(defaultRange.to.toISOString());
    setSelectedRange(defaultRange);
    setSearchValue("");
    setCurrentPage(1);
    setShouldFetchData(1);
    setResetButtonDisabled(true);
    setFilterButtonDisabled(true);
    setFiltersApplied(false);
  };

  const systemLogDataExport = async () => {
    let selectedRowsIds;
    if (selectedDataForExport.length === 0) {
      selectedRowsIds = "all";
    } else {
      selectedRowsIds = selectedDataForExport;
    }
    const timestamp = new Date().getTime();
    const fileName = `systemLog_${timestamp}.xlsx`;
    await exportSystemLogDataAction(searchValue, currentPage, ITEMS_PER_PAGE.value, typeFilter, userOperationFilter, moduleId, startDate, endDate, userNameFilter, selectedRowsIds)
      .then((response) => {
        const blob = new Blob([response]);
        setExportData({ blob: blob, fileName: fileName });
        setOpenExportModal(true);
      })
      .catch((error) => {
        setSnackbar({
          open: true,
          message: error.message,
          severity: "error",
        });
      });
  };

  const columns = [
    // {
    //   field: "id",
    //   minWidth: 40,
    //   headerName: "",
    //   sortable: false,
    //   filterable: false,
    //   disableColumnMenu: true,
    //   renderHeader: (params) => (
    //     <Checkbox
    //       onChange={handleSelectAll}
    //       disabled={logsData.length === 0}
    //       checked={logsData.length > 0 && selectedRows.length === logsData.length}
    //       sx={MyCheckboxIcon}
    //     />
    //   ),
    //   renderCell: (params) => (
    //     <Checkbox
    //       onChange={(event) => handleRowSelection(event, params.row)}
    //       checked={selectedRows.includes(params.row.id)}
    //       sx={MyCheckboxIcon}
    //     />
    //   ),
    // },
    {
      field: "Module Name",
      minWidth: 150,
      renderCell: (params) => <>{params.row.moduleDetail?.moduleName || "-"}</>,
      flex: 1,
    },
    {
      field: "User Operation",
      minWidth: 150,
      renderCell: (params) => <>{params.row.action || "-"}</>,
      flex: 1,
    },
    {
      field: "User Name",
      minWidth: 150,
      renderCell: (params) => <>{params.row?.user?.firstName + " " + params.row?.user?.lastName || "-"}</>,
      flex: 1,
    },
    {
      field: "type",
      minWidth: 150,
      renderCell: (params) => {
        const statusMap = {
          success: { text: "Success", status: "success" },
          error: { text: "Error", status: "danger" },
        };

        const statusKey = params.row?.type ?? "error";

        const { text, status } = statusMap[statusKey] || {
          text: "Unknown",
          status: "default",
        };

        return renderStatusBadge({ status, title: text });
      },
      flex: 1,
    },
    {
      field: "IP Address",
      minWidth: 150,
      renderCell: (params) => <>{params.row.ipAddress || "-"}</>,
      flex: 1,
    },
    {
      field: "Date And Time",
      minWidth: 150,
      renderCell: (params) => <>{formatDateTime(params.row.createdAt, true)}</>,
      flex: 1,
    },
    ...(hasPermission?.canDelete
      ? [
          {
            field: "Delete",
            minWidth: 100,
            width: 100,
            headerName: "Delete",
            sortable: false,
            renderCell: (params) => (
              <IconButton onClick={(e) => handleDelete(e, params.row.id)}>
                <MyDeleteOutlineOutlinedIcon />
              </IconButton>
            ),
          },
        ]
      : []),
  ];

  const handleFilterData = () => {
    setLoading(true);
    setCurrentPage(1);
    setLogsData([]);
    setShouldFetchData(1);
    setFilterButtonDisabled(true);
    setResetButtonDisabled(false);
    setFiltersApplied(true);
  };

  return (
    <>
      <div id="kt_content_container">
        <BreadcrumbsComponent />
        <DataGrid
          className="border-0"
          localeText={{ toolbarColumns: "" }}
          rows={logsData}
          columns={columns}
          autoHeight
          hideFooterRowCount={true}
          hideFooterPagination={true}
          hideFooter={true}
          loading={loading}
          slots={{
            toolbar: CustomToolbar,
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          slotProps={{
            toolbar: {
              selectedRows,
              handleDeleteSelected,
              searchValue,
              handleSearchApi,
              handleFilterData,
              handleResetFilters,
              handleChangeDropdown,
              typeFilter,
              selectedRange,
              onRangeChange: handleRangeChange,
              userOperationFilter,
              userNameFilter,
              usersDataForDropdown,
              logsData,
              moduleId,
              moduleOptions,
              systemLogDataExport,
              filterButtonDisabled,
              resetButtonDisabled,
            },
          }}
          components={{
            loadingOverlay: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <CircularProgress
                  color="primary"
                  size={24}
                  style={{
                    marginRight: 10,
                  }}
                />
                Loading...
              </div>
            ),
            noRowsOverlay: () =>
              loading ? null : (
                <div
                  style={{
                    display: !loading && logsData.length === 0 ? "block" : "none",
                    fontWeight: "bold",
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  No Records Found
                </div>
              ),
          }}
          sx={DataGrid_SX}
        />
        <div className="card-footer d-flex align-items-center justify-content-between mt-7">
          <div className="d-flex align-items-center">
            <label className="fw-semibold me-3">{"Row per page"} </label>
            <FormControl
              variant="standard"
              style={{
                minWidth: 50,
              }}
            >
              <Select
                labelId="rows-per-page-label"
                id="rows-per-page"
                value={selectedRowsPerPage}
                onChange={handleRowsPerPageChange}
                label="Row per page"
              >
                {ITEMS_PER_PAGE_OPTIONS?.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <Pagination
            count={Math.ceil(totalRecords / selectedRowsPerPage)}
            siblingCount={0}
            page={currentPage}
            onChange={(event, value) => {
              if (value !== currentPage) {
                setCurrentPage(value);
                setShouldFetchData(1);
                setLogsData([]);
                setSelectedRows([]);
                setLoading(true);
              }
            }}
            variant="outlined"
            shape="rounded"
            className="custom-pagination mt-0 ms-5"
          />
        </div>
        {openExportModal && (
          <ExportDataModal
            isOpen={openExportModal}
            onClose={() => {
              setOpenExportModal(false);
            }}
            blobData={exportData}
            data={selectedDataForExport}
            setSnackbar={setSnackbar}
          />
        )}
        <CustomSnackbar
          open={snackbar.open}
          message={snackbar.message}
          severity={snackbar.severity}
          onClose={handleCloseSnackbar}
        />
      </div>
    </>
  );
};

export default LogsSection;